__turbopack_context__.v({
  "cta": "CoreRelatedNewsInsightsGrid-module-scss-module__7gllIq__cta",
  "description": "CoreRelatedNewsInsightsGrid-module-scss-module__7gllIq__description",
  "grid": "CoreRelatedNewsInsightsGrid-module-scss-module__7gllIq__grid",
  "heading": "CoreRelatedNewsInsightsGrid-module-scss-module__7gllIq__heading",
  "pdf": "CoreRelatedNewsInsightsGrid-module-scss-module__7gllIq__pdf",
});
